/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AltRouteOutlinedIcon from "@mui/icons-material/AltRouteOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";


const LogisticHub = () => {
    const navigate = useNavigate();
  
    return (
        <>
            {/* ---------- Page Header ---------- */}
            <div className="main_title">
                <h1>Logistics Hub</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Logistics Hub
                </p>
            </div>

            <div className="stats_boxes gap_m">
                {/* ORDERS PENDING */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            2
                            <p>Orders Pending</p>
                        </h2>
                        <figure className="warning">
                            <PendingActionsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

              
                </a>

                {/* ACTIVE SHIPMENTS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            1
                            <p>Active Shipments</p>
                        </h2>
                        <figure className="blue">
                            <LocalShippingOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                
                </a>

                {/* ACTIVE ROUTES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Active Routes</p>
                        </h2>
                        <figure className="sucess">
                            <AltRouteOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                   
                </a>

                {/* DELIVERY SUCCESS RATE */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            93.3%
                            <p>Delivery Success Rate</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                   
                </a>
            </div>
            <div className="logistics_dashboard mt_20">
                <div className="dashboard_grid">

                    {/* ORDERS NEEDING ATTENTION */}
                    <div className="cards dashboard_card">
                        <div className="card_head">
                            <h4>Orders Needing Attention</h4>
                            <a href="/orders" onClick={() => navigate("/orders")}>View All</a>
                        </div>

                        <ul className="list_simple">
                            <li>
                                <div>
                                    <b>ORD-2025-004</b>
                                    <p>Mohammed Al Mansoori</p>
                                </div>
                                <span className="badge warning">Delayed</span>
                            </li>

                            <li>
                                <div>
                                    <b>ORD-2025-005</b>
                                    <p>Aisha Rahman</p>
                                </div>
                                <span className="badge warning">Pending</span>
                            </li>
                        </ul>
                    </div>

                    {/* ACTIVE SHIPMENTS */}
                    <div className="cards dashboard_card">
                        <div className="card_head">
                            <h4>Active Shipments</h4>
                            <a href="/shipments" onClick={() => navigate("/shipments")}>View All</a>
                        </div>

                        <ul className="list_simple">
                            <li>
                                <div>
                                    <b>TRK-10092</b>
                                    <p>Aramex</p>
                                </div>
                                <span className="badge success">In Transit</span>
                            </li>
                        </ul>
                    </div>

                    {/* ACTIVE ROUTES */}
                    <div className="cards dashboard_card full">
                        <div className="card_head">
                            <h4>Active Routes</h4>
                        </div>

                        <div className="route_progress">
                            <div className="route_row">
                                <div className="route_info">
                                    <b>Dubai Morning Route</b>
                                    <small>Ahmed Hassan</small>
                                </div>
                                <span>82%</span>
                            </div>
                            <div className="progress_bar">
                                <span style={{ width: "82%" }} />
                            </div>

                            <div className="route_row">
                                <div className="route_info">
                                    <b>Abu Dhabi Route</b>
                                    <small>Fatima Ahmed</small>
                                </div>
                                <span>61%</span>
                            </div>
                            <div className="progress_bar">
                                <span style={{ width: "61%" }} />
                            </div>

                            <div className="route_row">
                                <div className="route_info">
                                    <b>Northern Emirates Route</b>
                                    <small>Omar Ibrahim</small>
                                </div>
                                <span>48%</span>
                            </div>
                            <div className="progress_bar">
                                <span style={{ width: "48%" }} />
                            </div>
                        </div>
                    </div>

                    {/* DELIVERY PERFORMANCE */}
                    <div className="cards dashboard_card">
                        <div className="card_head">
                            <h4>Delivery Performance (Last 7 Days)</h4>
                        </div>

                        <ul className="performance_list">
                            <li>
                                <span>09/12/2025</span>
                                <b className="success">96% Success</b>
                            </li>
                            <li>
                                <span>08/12/2025</span>
                                <b className="success">94% Success</b>
                            </li>
                            <li>
                                <span>07/12/2025</span>
                                <b className="success">92% Success</b>
                            </li>
                        </ul>
                    </div>

                    {/* QUICK ACTIONS */}
                    <div className="cards dashboard_card">
                        <div className="card_head">
                            <h4>Quick Actions</h4>
                        </div>

                        <div className="quick_actions">
                            <button onClick={() => navigate("/orders")}>View All Orders</button>
                          
                            <button onClick={() => navigate("/routes")}>Manage Routes</button>
                         
                        </div>
                    </div>

                </div>
            </div>
      
        </>
    );
};

export default LogisticHub;
